import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { WsFilterDialog, WsFilterDialogProps } from 'wisestep-base';

const WsMultiSelectSmartFilter = ({ children, name, ...props }: WsFilterDialogProps) => {
  const form = useFormContext();
  const selected = form.watch(name) ?? [];

  return (
    <WsFilterDialog name={selected.length > 0 ? `selected ${selected.length}` : 'All'} {...props}>
      <Grid px={1} py={2} item xs={4} minWidth={480}>
        {children}
      </Grid>
    </WsFilterDialog>
  );
};

export default WsMultiSelectSmartFilter;
